export default function NotFoundPage() {

  return (
    <div id="404-page">
      <h1>404</h1>
      <p>Page not found</p>
    </div>
  );
}
